export default __webpack_public_path__ + "static/media/Team.977b3fb3.svg";